var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 14.3594V10.1044C21.3828 9.09855 21.15 8.1026 20.6977 7.17336C20.2454 6.24413 19.5825 5.3998 18.7468 4.68859C17.911 3.97739 16.9189 3.41323 15.827 3.02832C14.735 2.64342 13.5647 2.44531 12.3828 2.44531C11.2009 2.44531 10.0306 2.64342 8.93866 3.02832C7.84673 3.41323 6.85458 3.97739 6.01885 4.68859C5.18312 5.3998 4.52019 6.24413 4.0679 7.17336C3.6156 8.1026 3.38281 9.09855 3.38281 10.1044V14.3594",
    stroke: "#FB7401",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38104 12.4012L3.38104 16.6563C3.38104 17.6621 3.45746 18.7655 3.90976 19.6948C4.36205 20.624 4.99194 21.4326 6.01708 22.072C7.04222 22.7115 8.28651 22.8867 9.58594 22.8867",
    stroke: "#FB7401",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3866 12.3176C16.3866 11.8066 16.3866 11.5506 16.4456 11.3476C16.5806 10.8796 16.9356 10.5236 17.3756 10.4136C18.6476 10.0956 18.9056 11.2776 19.8186 11.6456L19.8876 11.6736C20.8796 12.0906 21.3846 13.1516 21.3826 14.2276V14.5846C21.3796 15.5346 20.8726 16.4196 20.0296 16.8566C19.0906 17.3416 18.7776 18.6086 17.4146 18.3166C16.9776 18.2226 16.6176 17.8876 16.4646 17.4336C16.3866 17.2026 16.3866 16.8996 16.3866 16.2976V12.3176ZM8.38663 16.4016C8.38663 16.9126 8.38663 17.1676 8.32763 17.3716C8.19263 17.8396 7.83763 18.1956 7.39763 18.3056C6.12563 18.6236 5.86763 17.4406 4.95463 17.0736L4.89263 17.0486C3.89463 16.6306 3.38863 15.5686 3.39063 14.4916V14.1276C3.39363 13.1816 3.89963 12.2996 4.74363 11.8626C5.68263 11.3776 5.99563 10.1106 7.35863 10.4026C7.79563 10.4966 8.15563 10.8316 8.30863 11.2856C8.38663 11.5166 8.38663 11.8186 8.38663 12.4216V16.4016Z",
    stroke: "#FB7401",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.58594,
    y: 21.5977,
    width: 5.58594,
    height: 2.02734,
    rx: 1.01367,
    stroke: "#FB7401",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/Headphones.44f2228082556510ebe198bbc905ab43.svg";
export { ForwardRef as ReactComponent };